<generic-search-results
        [showHeader]="false"
        [showCounter]="false"
        [title]="''"
        [records]="secretsDeleted"
        [displayedColumns]="secretColumns"
        [selectableRecords]="false"
        [allowLocalFilter]="false"
    ></generic-search-results>